module.exports = __webpack_public_path__ + "img/2.ceb50348.png";